import { render, staticRenderFns } from "./xeIndoorEnvInfo.vue?vue&type=template&id=06fef1f3&scoped=true"
import script from "./xeIndoorEnvInfo.vue?vue&type=script&lang=js"
export * from "./xeIndoorEnvInfo.vue?vue&type=script&lang=js"
import style0 from "./xeIndoorEnvInfo.vue?vue&type=style&index=0&id=06fef1f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fef1f3",
  null
  
)

export default component.exports